// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1676":"9c18595a","6291":"115785ff"}[chunkId] + ".chunk.css";
};